import actions from '@/store/modules/hotsite-slots/actions.js'
import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/hotsite-slots/state.js'
import mutations from '@/store/modules/hotsite-slots/mutations.js'
import getters from '@/store/modules/hotsite-slots/getters.js'

export default {
  actions,
  state: cloneDeep(state),
  mutations,
  getters,
}
